import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import withFetchHook from "./withFetchHook";

class ProfilePicture extends Component {
  state = {
    loading: false,
    profilePictureUrl: "/images/original/missing.png"
  }

  componentDidMount() {
    this.setState({
      profilePictureUrl: this.props.resident.profile_picture_url
    })
  }

  handleChange(e) {
    const { organizationName, resident } = this.props;

    const formData = new FormData();
    formData.append("resident[profile_picture]", e.target.files[0]);

    this.setState({ loading: true });
    this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}/upload_profile_picture.json`, {
      method: "PATCH",
      data: formData,
      processData: false,
      cache: false,
      contentType: false
    }).then((data) => {
      this.setState({
        loading: false,
        profilePictureUrl: data.profile_picture_url
      });
    });
  }

  renderUpdateButton() {
    if (this.state.loading) {
      return (
        <div className="d-flex justify-content-center">
          <Button disabled={true} variant="link" size="sm">
            Updating...
          </Button>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center">
        <label className="btn btn-sm btn-link" htmlFor="resident-profile-picture">Change Picture</label>
        <input
          type="file"
          id="resident-profile-picture"
          className="sr-only"
          accept="image/*"
          onChange={this.handleChange.bind(this)} />
      </div>
    );
  }

  render() {
    const { resident, permissions } = this.props;
    const canEdit = permissions ? permissions.includes("edit_everything") : this.props.action === "edit";

    return (
      <div className="text-center">
        <img src={this.state.profilePictureUrl} className="profile-picture-responsive img-fluid img-thumbnail" />
        {canEdit && this.renderUpdateButton()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    organizationName: state.organization.name,
    resident: state.resident,
    action: state.ui.action
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(ProfilePicture));
